const NoAuthContainer = () => import('@/components/Common/NoAuthContainer');
const ExpirePack = () =>
  import('@/components/Organisations/Billing/ExpirePack');
export default {
  path: '/expire',
  component: NoAuthContainer,
  meta: {
    noMenuItems: true
  },
  children: [
    {
      path: 'pack',
      component: ExpirePack,
      meta: {
        noMenuItems: true,
        canClickXiftLogo: false
      }
    }
  ]
};
